import { parseToValidUrl as u } from "../../../../modules/RichEditor/services/parseToValidUrl/index.js";
function d(r) {
  function i(n) {
    n.clipboard.addMatcher(Node.TEXT_NODE, (o, e) => {
      const t = u(o.data || "");
      if (!t)
        return e;
      e.ops = [];
      const s = t ? { link: t } : void 0;
      return e.insert(t || "", s);
    });
  }
  return r.register("modules/pastelink", i, !0), { modules: { pastelink: !0 } };
}
export {
  d as PasteSimpleLinkExtension
};
